export default "__VITE_ASSET__AgPU6vSW__"